<div class="{{ look }}">
  @if (field.formControlType === formFieldTypes.INPUT && !field.hidden) {
    <mat-form-field
      class="loren-form-field"
      [formGroup]="formGroup"
      [ngClass]="{ 'mb-3': field.validator, 'w-100': fullLength }">
      <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
      <input
        matInput
        [formControlName]="field.name"
        (keyup)="handleFormFieldInteraction($event, field)"
        [placeholder]="field.placeholder | transloco"
        [type]="resolveInputType()"
        [value]="field.value" />
      <!-- TODO: extract in template to reuse in other fields -->
      @if (passwordField) {
        <mat-icon
          class="hover-pointer"
          matSuffix
          (click)="hidePassword = !hidePassword"
          >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
          >
        }
        @if (field.hint && !field.translateHint) {
          <mat-hint align="end">{{
            field.hint
          }}</mat-hint>
        }
        @if (field.hint && field.translateHint) {
          <mat-hint align="end">{{
            field.hint | transloco
          }}</mat-hint>
        }
        @if (hasError(field.name, 'required')) {
          <mat-error>
            {{ "errors.field_required" | transloco }}
          </mat-error>
        }
        @if (hasError(field.name, 'minlength')) {
          <mat-error>
            {{
            "errors.field_minlength"
            | transloco : { value: field.validator.minLength }
            }}
          </mat-error>
        }
        @if (hasError(field.name, 'maxlength')) {
          <mat-error>
            {{
            "errors.field_maxlength"
            | transloco : { value: field.validator.maxLength }
            }}
          </mat-error>
        }
        @if (hasError(field.name, 'pattern')) {
          <mat-error>
            {{ "errors.field_pattern" | transloco }}
          </mat-error>
        }
      </mat-form-field>
    }

    @if (field.formControlType === formFieldTypes.TEXTAREA && !field.hidden) {
      <mat-form-field
        class="loren-form-field"
        [formGroup]="formGroup">
        <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
        <textarea
          matInput
          (keyup)="handleFormFieldInteraction($event, field)"
          [formControlName]="field.name"
          [placeholder]="field.placeholder"
          [value]="field.value">
        </textarea>
      </mat-form-field>
    }

    @if (field.formControlType === formFieldTypes.SELECT && !field.hidden) {
      <mat-form-field
        class="loren-form-field"
        [formGroup]="formGroup">
        <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
        <mat-select
          (valueChange)="handleFormFieldInteraction($event, field)"
          [formControlName]="field.name"
          [multiple]="field.multiple"
          [value]="!field.multiple ? field.value : field.values"
          [disabled]="field.disabled"
          [placeholder]="field.placeholder | transloco">
          @for (option of field.options; track option) {
            <mat-option
              [value]="option.value"
              [disabled]="option.disabled">
              {{ option.key | transloco }}
              @if (option.optionDescription) {
                <span>&nbsp;({{ option.optionDescription }})</span>
              }
            </mat-option>
          }
        </mat-select>
        @if (hasError(field.name, 'required')) {
          <mat-error>
            {{ "errors.field_required" | transloco }}
          </mat-error>
        }
      </mat-form-field>
    }

    @if (
      field.formControlType === formFieldTypes.AUTOCOMPLETE && !field.hidden
      ) {
      <mat-form-field
        class="loren-form-field"
        [formGroup]="formGroup">
        <input
          matInput
          [placeholder]="field.placeholder | transloco"
          [matAutocomplete]="auto"
          [formControlName]="field.name"
          (keyup)="handleAutoCompleteFiltering(field)" />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionActivated)="handleAutoCompleteValueSelection($event, field)"
          (optionSelected)="handleAutoCompleteValueSelection($event, field)">
          @for (option of field.filteredOptions; track option) {
            <mat-option
              [value]="option.key">
              @if (field.optionValueImgProperty) {
                <img
                  class="autocomplete-option-img mr-2"
                  alt="Image"
          [src]="
            option.value[field.optionValueImgProperty] | lorenImage | async
          "
                  height="25" />
              }
              <span>{{ option.key | transloco }}</span>
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    }

    @if (field.formControlType === formFieldTypes.CHECKBOX && !field.hidden) {
      <div
        [formGroup]="formGroup"
        class="{{ field.look }}">
        <mat-checkbox
          (change)="handleFormFieldInteraction($event, field)"
          [formControlName]="field.name"
          [checked]="field.value"
          [value]="field.value">
          {{ field.label | transloco : field.labelOptions }}
        </mat-checkbox>
      </div>
    }

    @if (field.formControlType === formFieldTypes.DATETIME && !field.hidden) {
      <mat-form-field
        class="loren-form-field"
        [formGroup]="formGroup">
        <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
        <input
          matInput
          [value]=""
          [matDatepicker]="picker"
          (dateChange)="handleFormFieldInteraction($event, field)"
          [max]="field.maxValue"
          [formControlName]="field.name" />
        <mat-datepicker-toggle
          class="date_container"
          matSuffix
        [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker [touchUi]="isHandset" #picker></mat-datepicker>
      </mat-form-field>
    }

    @if (field.formControlType === formFieldTypes.COLOR && !field.hidden) {
      <mat-form-field
        class="loren-form-field"
        [formGroup]="formGroup">
        <mat-label>{{ field.label | transloco : field.labelOptions }}</mat-label>
        <mat-select
          (valueChange)="handleFormFieldInteraction($event, field)"
          [formControlName]="field.name"
          [multiple]="field.multiple"
          [style.background]="field.value"
          [value]="!field.multiple ? field.value : field.values"
          [placeholder]="field.placeholder">
          @for (color of colors; track color) {
            <mat-option
              class="color-option"
              [value]="color.hexCode"
              [style.background]="color.hexCode">
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    <div [formGroup]="formGroup">
      @if (
        field.formControlType === formFieldTypes.SLIDE_TOGGLE && !field.hidden
        ) {
        <mat-slide-toggle
          class="{{ field.look }}"
          [formControlName]="field.name"
          (change)="handleFormFieldInteraction($event, field)"
          [disabled]="field.disabled"
          [checked]="field.value">
          {{ field.label | transloco : field.labelOptions }}
        </mat-slide-toggle>
      }
    </div>

    @if (field.formControlType === formFieldTypes.FORM_SEPARATOR) {
      <div class="pt-2 ml-3 pb-2 h1">{{ field.label | transloco }}</div>
      <mat-divider></mat-divider>
      <div class="pb-3"></div>
    }

    @if (field.formControlType === formFieldTypes.PERIOD && !field.hidden) {
      <loren-period-selector
        (periodChange)="handleFormFieldInteraction($event, field)">
      </loren-period-selector>
    }

    @if (field.formControlType === formFieldTypes.CALENDAR) {
      <div class="text-muted">
        {{ field.label | transloco }}
      </div>
      <div class="">
        <mat-calendar
          #calendar
          [selected]="field.value"
          [minDate]="field.minValue"
          [dateClass]="isCalendarSelectedDate"
          (selectedChange)="selectCalendarDate($event, calendar)">
        </mat-calendar>
      </div>
    }
  </div>
